// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Context = require("../../../../provider/Context.bs.js");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Cell = require("../../../atom/Atom_Cell.bs.js");
var UseOnBlur = require("../../../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../../../hook/UseToggle.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var UseClickOutside = require("../../../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Molecule_BurgerMenuIcon = require("../../../molecule/Molecule_BurgerMenuIcon.bs.js");
var Molecule_BurgerMenuIcon_Ds = require("../../../molecule/Molecule_BurgerMenuIcon_Ds.bs.js");
var Organism_HeaderAccessibility = require("../Organism_HeaderAccessibility.bs.js");
var Organism_ConcertMenuNavigation = require("./Organism_ConcertMenuNavigation.bs.js");

function Organism_ConcertBurgerMenu(Props) {
  var links = Props.links;
  var display = Props.display;
  var socialNetworks = Props.socialNetworks;
  var selectGenre = Props.selectGenre;
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.navbar;
  var match$2 = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match$2.close;
  var state = match$2.state;
  var toggle = match$2.toggle;
  var ref = React.useRef(null);
  var ffNewConcertHeader = Context.Config.getFeatureFlippingStatus(/* NewConcertHeader */11);
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  var burgerCta = ffNewConcertHeader ? React.createElement(Atom_Cta.Button.make, {
          accessibility: Organism_HeaderAccessibility.accessibility(state),
          onClick: toggle,
          screenReadersLabel: "Menu",
          style: {
            TAG: /* Header */10,
            _0: {
              TAG: /* BurgerMenu */0,
              _0: state,
              _1: ffNewConcertHeader
            }
          }
        }) : React.createElement(Molecule_BurgerMenuIcon.make, {
          state: state,
          toggle: toggle,
          style: Molecule_BurgerMenuIcon_Ds.header
        });
  var tmp = {
    kind: {
      TAG: /* Nav */10,
      _0: match$1.mainNavigation
    },
    children: null,
    rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position(CssJs.unset)]),
    ref_: ref
  };
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  return React.createElement(Atom_Cell.make, tmp, burgerCta, React.createElement(Organism_ConcertMenuNavigation.make, {
                  links: links,
                  state: state,
                  socialNetworks: socialNetworks,
                  selectGenre: selectGenre
                }));
}

var make = Organism_ConcertBurgerMenu;

exports.make = make;
/* CssJs Not a pure module */
